import { useRBACContext } from "@impelsysinc/react-rbac";
import AuiButton from "../../components/Buttons/Buttons";
import FilterSection from "../../components/Filters/FilterSection";
import MoreOption from "../../components/MoreOptions/MoreOption";
import "./CourseListing.scss";
import { useState, useEffect, useRef } from "react";
import {
  deleteTrainingSession,
  listTrainingSession,
  getTrainingSessionListExport,
  TrainingSessionListParam,
} from "../../services/training-session.service";
import AuiPrimaryPagination from "../../components/AuiDropdown/AuiPagination";
import noRecord from "./../../assets/images/no-recs.png";
import { useNavigate } from "react-router-dom";
import TableStatus from "../../components/TableStatus/TableStatus";
import { SessionStatusConstants, SessionStatusTypes } from "../../utils/constants/session-status-constants";
import AuiIcon from "../../components/AuiDropdown/AuiIcon";
import { AuiConfirmationModal } from "../../components/Modals/ModalPopUp";
import { useDispatch } from "react-redux";
import { showAlert } from "../../store/alertSlice";
import { formatDate } from "../../components/Hooks/dateTimeHooks";
interface CourseOption {
  label: string;
  value: string;
}

const CourseListing = () => {
  const [courseType, setCourseType] = useState<CourseOption>({
    label: "",
    value: "",
  });
  const [statusType, setStatusType] = useState<CourseOption>({
    label: "",
    value: "",
  });
  const [collabOrg, setCollabOrg] = useState<CourseOption>({
    label: "",
    value: "",
  });
  const [classType, setClassType] = useState<CourseOption>({
    label: "",
    value: "",
  });
  const { canAccess } = useRBACContext();
  const dispatch = useDispatch();
  const [sessionItems, setSessionItems] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [courseSearchTerm, setCourseSearchTerm] = useState<string>("");

  const canAccessCourse = canAccess({
    action: "*",
    resource: "course",
  });
  
  const [pagination, setPagination] = useState({
    isFirst: true,
    isLast: false,
    pageNumber: 1,
    pageSize: 10,
    totalItems: 0,
    totalPages: 0,
    rowsperpage: 10,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [modal, setModal] = useState({ isOpen: false, sessionId: null });
  const pageOrder = "id dsc";
  const navigate = useNavigate();
  const editableStatuses = ["DRAFT", "PENDING", "REJECTED"];
  const noDataRef = useRef<HTMLDivElement>(null);

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setCurrentPage(1);
  };

    const getSessionList = async () => {
      setIsLoading(true);
      setSessionItems([]);
      
      let isHybrid: boolean | undefined = undefined;

      if (classType.value === "Classic") {
        isHybrid = false;
      } else if (classType.value === "Hybrid") {
        isHybrid = true;
      }

      try {
        const list = await listTrainingSession({
          status: statusType.value,
          trainingType: courseType.value,
          sponsoringOrganizationID: collabOrg.value,
          isHybrid,
          pageNumber: currentPage,
          pageSize,
          pageOrder,
          search: courseSearchTerm,
        });
        const newData = list.data.trainingSessions || [];
        setSessionItems(newData);
        setPagination({
          isFirst: !!list._pagination?.isFirst,
          isLast: list._pagination?.isLast || false,
          totalItems: list._pagination?.totalCount || 0,
          totalPages: list._pagination?.totalPages || 0,
          pageNumber: list._pagination?.pageNumber || 1,
          pageSize: list._pagination?.pageSize || 10,
          rowsperpage: list._pagination?.pageSize || 10,
        });
      } catch (error) {
        console.error("Error fetching trainers:", error);
        setSessionItems([]);
      } finally {
        setIsLoading(false);
      }
    };

  useEffect(() => {
    getSessionList();
  }, [currentPage, pageSize, statusType, courseType, classType, collabOrg, pageOrder, courseSearchTerm]);

  const handleDeleteClick = (sessionId: any) => {
    setModal({ isOpen: true, sessionId });
  }

  const handleCancel = () => {
    setModal({ isOpen: false, sessionId: null });
  };

  const handleDelete = async (sessionId: any) => {
    try {
      const response = await deleteTrainingSession(sessionId);
      if(response?.status === 200) {
        dispatch(showAlert({ message:"Course has been deleted successfully!", type: "success" }));
      }
      getSessionList();
      handleCancel();
    } catch (error) {
      console.error("Error deleting session:", error);
    }
  };

  useEffect(() => {
    if (!isLoading && sessionItems.length === 0 && noDataRef.current) {
      noDataRef.current.focus();
    }
  }, [isLoading, sessionItems]);
  
    const exportTrainingSessionExcel = () => {
      exportTrainingSessionList();
    };

    const exportTrainingSessionList = async () => {
      let isHybrid: boolean | undefined = undefined;

      if (classType.value === "Classic") {
        isHybrid = false;
      } else if (classType.value === "Hybrid") {
        isHybrid = true;
      }

      try {
        const params: TrainingSessionListParam = {
          trainingType: courseType.value,
          status: statusType.value,
          sponsoringOrganizationID: collabOrg.value,
          isHybrid,
          search: courseSearchTerm,
        };

        const result = await getTrainingSessionListExport(params);

        if (result?.status === 200 && result.data?.Data?.url) {
          window.open(result.data.Data.url, "_self");
        }
      } catch (error) {
        console.error("Error while fetching training session report:", error);
      }
    };
  
  return (
    <div className="center-container">
      <div className="main-course-container">
        <main className="container px-1">
          <FilterSection
            setCourseType={setCourseType}
            setStatusType={setStatusType}
            setCurrentPage={setCurrentPage}
            setCollabOrg={setCollabOrg}
            setClassType={setClassType}
            setCourseSearchTerm={setCourseSearchTerm}
          />
          <div className="course-list-container py-3 pt-lg-5">
            <div className="pl-2">
              <section className="sort-item row">
                <div className="col-12 d-flex justify-content-between">
                  <output className="item-count" aria-live="polite">
                    {sessionItems.length
                      ? `Showing ${
                          (currentPage - 1) * pageSize + 1
                        } to ${Math.min(
                          currentPage * pageSize,
                          pagination.totalItems
                        )} items out of ${pagination.totalItems}`
                      : ""}
                  </output>
                  {sessionItems.length > 0 && (
                    <div className="d-flex align-items-center export">
                      <aui-icon
                        block={true}
                        svgclass="aui-icon-export"
                        pathclass="aui-path-export"
                        icon="export"
                        svgwidth="20"
                        svgheight="20"
                      ></aui-icon>
                      <button
                        type="button"
                        className="export-text export-btn ml-1"
                        onClick={exportTrainingSessionExcel}
                      >
                        Export
                      </button>
                    </div>
                  )}
                </div>
              </section>
              {isLoading && (
                <div className="aui-loader">
                  <aui-loader type="content"></aui-loader>
                </div>
              )}
              {!isLoading && (sessionItems.length > 0 ? (
                <>
                <h2 id="course-table-title" className="sr-only">
                    Basic Emergency Care Course Listing
                </h2>
                <section className="course-table" aria-labelledby="course-table-title">
                  <aui-table
                    type="status"
                    headerbackground={true}
                    headerborder={true}
                  >
                    <table>
                      <thead>
                        <tr>
                        <th scope="col" className="RefIdHeader">
                            <div className="aui-th">Reference ID</div>
                          </th>
                          <th scope="col">
                            <div className="aui-th">Courses</div>
                          </th>
                          <th scope="col">
                            <div className="aui-th">Class Types</div>
                          </th>
                          <th scope="col" className="statusHeader">
                            <div className="aui-th">Status</div>
                          </th>
                          <th scope="col" className="locationHeader">
                            <div className="aui-th">Location</div>
                          </th>
                          <th scope="col" className="startDateHeader">
                            <div className="aui-th">Start Date</div>
                          </th>
                          <th scope="col" className="actionHeader">
                            <div className="aui-th d-flex justify-content-lg-center pl-3">
                            {canAccessCourse ? "Actions" : "Action"}
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {sessionItems.map((item) => {
                          const { code, id, trainingTypeCode, isHybrid, status, startDate, sessionGeoGrapghy } =
                            item;
                          const city = sessionGeoGrapghy?.city;
                          const country = sessionGeoGrapghy?.country?.name;
                          const isEditable = editableStatuses.includes(status);
                          const location = [city, country].filter(value => value != null).join(", ");
                          const isEmptyLocation = !location;
                          return (
                            <tr
                              className={`table-tr ${
                                SessionStatusConstants[
                                  status as SessionStatusTypes
                                ].auiTableRowBorderClass
                              }`}
                              key={id}
                            >
                              <td data-title="Reference ID">
                                <button
                                  className="aui-td td-link bg-transparent"
                                  onClick={() =>
                                    navigate(`/course/view-course?id=${id}`)
                                  }
                                >
                                  {code}
                                </button>
                              </td>
                              <td data-title="Courses">
                                <div className="aui-td">{trainingTypeCode}</div>
                              </td>
                              <td data-title="ClassType">
                                <div className="aui-td">
                                  {isHybrid ? "Hybrid" : "Classic"}
                                </div>
                              </td>
                              <td data-title="Status">
                                <div className="aui-td">
                                  <TableStatus status={status}></TableStatus>
                                </div>
                              </td>
                              <td data-title="Location">
                                <div
                                  className={`aui-td ${
                                    isEmptyLocation ? "isEmptyLocation" : ""
                                  }`}
                                >
                                  {location || "-"}
                                </div>
                              </td>
                              <td data-title="Start Date">
                                <div className="aui-td">
                                  {formatDate(startDate)}
                                </div>
                              </td>
                              <td data-title="Actions">
                                <div className="d-flex position-relative aui-td justify-content-lg-center">
                                  <MoreOption
                                    ariaLabel="More options"
                                    className="text-center"
                                  >
                                    <ul>
                                      <li>
                                        <AuiIcon iconClass="view" />
                                        <AuiButton
                                          variant="button-text-styled"
                                          buttontitle="View"
                                          modalid="exampleModal"
                                          size="small"
                                          buttonid={""}
                                          buttonclass="actionBtn px-2"
                                          buttonClick={() =>
                                            navigate(
                                              `/course/view-course?id=${id}`
                                            )
                                          }
                                        ></AuiButton>
                                      </li>
                                      {isEditable && canAccessCourse && (
                                        <>
                                          <li>
                                            <AuiIcon iconClass="editsquare" />
                                            <AuiButton
                                              variant="button-text-styled"
                                              buttontitle="Edit"
                                              modalid="exampleModal"
                                              size="small"
                                              buttonid={""}
                                              buttonclass="actionBtn px-2"
                                              buttonClick={() =>
                                                navigate(
                                                  `/create-course/classDetails?id=${id}`
                                                )
                                              }
                                            ></AuiButton>
                                          </li>
                                          <li>
                                            <AuiIcon iconClass="trash" />
                                            <AuiButton
                                              variant="button-text-styled"
                                              buttontitle="Delete"
                                              modalid="exampleModal"
                                              size="small"
                                              buttonid={""}
                                              buttonclass="actionBtn px-2"
                                              ifmodal={true}
                                              data-backdrop="static"
                                              data-keyboard="false"
                                              buttonClick={() =>
                                                handleDeleteClick(id)
                                              }
                                            ></AuiButton>
                                          </li>
                                        </>
                                      )}
                                    </ul>
                                  </MoreOption>
                                  {modal.isOpen && (
                                    <AuiConfirmationModal
                                      modalsize="auimodal-sm"
                                      title="Delete Course"
                                      text="Are you sure you want to delete the course?"
                                      icon={<AuiIcon iconClass="trash" />}
                                      buttontitle="Delete"
                                      alertText="Test alert text."
                                      handleConfirmationClick={() =>
                                        handleDelete(modal.sessionId)
                                      }
                                      close={handleCancel}
                                    />
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </aui-table>
                </section>
                </>
              ) : (
                <output
                  className="aui-status-table-emptystate aui-table-empty results-empty-sec d-block"
                  aria-live="polite" aria-atomic="true"
                >
                  <div className="aui-table-no-data d-flex flex-column justify-content-center align-items-center">
                    <img src={noRecord} alt="No data available illustration" aria-hidden="true"/>
                    <h2 className="mb-0" ref={noDataRef} tabIndex={-1}>No Data Found</h2>
                      <span className="sr-only" role="alert" aria-live="assertive">
                        No data available.
                      </span>
                  </div>
                </output>
              ))}
              {sessionItems.length ? (
                <section className="pagination py-3 secPagination">
                  <div className="w-100">
                    <AuiPrimaryPagination
                      inputdata={pagination}
                      totalitems={pagination.totalItems}
                      rowsperpage={pagination.rowsperpage}
                      setCurrentPage={setCurrentPage}
                      setPageSize={handlePageSizeChange}
                    />
                  </div>
                </section>
              ) : null}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default CourseListing;
